var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwittersvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M10.1202 2.46702C10.127 2.55514 10.127 2.64328 10.127 2.7314C10.127 5.41927 7.90376 8.51632 3.84031 8.51632C2.58844 8.51632 1.42551 8.18268 0.447266 7.60359C0.625133 7.62246 0.796136 7.62876 0.980847 7.62876C2.01379 7.62876 2.96468 7.30773 3.72401 6.76008C2.75262 6.74119 1.93856 6.15578 1.65808 5.35004C1.79491 5.36891 1.93171 5.38151 2.07538 5.38151C2.27376 5.38151 2.47216 5.35632 2.65685 5.31227C1.64441 5.12341 0.88506 4.3051 0.88506 3.31682V3.29165C1.1792 3.44272 1.52127 3.53714 1.88381 3.54972C1.28866 3.18461 0.898746 2.56144 0.898746 1.85641C0.898746 1.47873 1.00818 1.13252 1.19973 0.830368C2.28743 2.06415 3.92239 2.86987 5.75571 2.95801C5.72151 2.80693 5.70098 2.64958 5.70098 2.49221C5.70098 1.37172 6.68607 0.458984 7.91057 0.458984C8.54676 0.458984 9.12138 0.704481 9.525 1.10105C10.0244 1.01293 10.5032 0.842962 10.9274 0.610061C10.7632 1.08218 10.4143 1.47875 9.95597 1.73053C10.4006 1.68649 10.8316 1.57315 11.2284 1.4158C10.9274 1.81865 10.5511 2.17744 10.1202 2.46702Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittersvg);
export default __webpack_public_path__ + "static/media/twittersvg.61374c62360342863dd801037551e895.svg";
export { ForwardRef as ReactComponent };